import React, { useCallback } from "react";
import { stringPresent } from "src/utils/strings";
import { useLocation } from "@gatsbyjs/reach-router";
import { useCustomPromo } from "components/CustomPromo/hooks";
import CustomPromoErrorModal from "components/CustomPromo/CustomPromoErrorModal/CustomPromoErrorModal";

const CustomPromoModal = React.lazy(() => import("./CustomPromoModal"));

type Props = {
  title: string;
};

const MaybeCustomPromoModal: React.FC<Props> = (props) => {
  const { promoState, updatePromoState } = useCustomPromo();

  const onRequestClose = useCallback(() => {
    updatePromoState({ showCustomPromoModal: false });
  }, [updatePromoState]);

  if (!promoState.showCustomPromoModal) {
    return null;
  }

  const isPromoExpired = (promoCode: string) => {
    if (promoCode !== "a") {
      return true;
    }

    const today = new Date();
    const expirationDate = new Date(2025, 7, 31);
    return today > expirationDate;
  };

  return (
    <React.Suspense>
      {isPromoExpired(promoState.promoCode) ? (
        <CustomPromoErrorModal
          isOpen={true}
          onRequestClose={onRequestClose}
          title={props.title}
        />
      ) : (
        <CustomPromoModal
          isOpen={true}
          onRequestClose={onRequestClose}
          title={props.title}
        />
      )}
    </React.Suspense>
  );
};

export default MaybeCustomPromoModal;
